import React from 'react'
import BankBuddy from '../components/Projects/bankBuddy'
import JAM from '../components/Projects/jam'
import Pomodoro from '../components/Projects/pomodoro'

export const Projects = () => {
  return (
    <div>
      <BankBuddy/>
      <JAM/>
      <Pomodoro/>
    </div>
  )
}

export default Projects
